// extracted by mini-css-extract-plugin
export default {"duration-picker":"DurationPicker_duration-picker__2x6qc","duration-input":"DurationPicker_duration-input__yofsC"};